import { render, staticRenderFns } from "./ExamTrueFalse.vue?vue&type=template&id=47d4810a&"
import script from "./ExamTrueFalse.vue?vue&type=script&lang=js&"
export * from "./ExamTrueFalse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d4810a')) {
      api.createRecord('47d4810a', component.options)
    } else {
      api.reload('47d4810a', component.options)
    }
    module.hot.accept("./ExamTrueFalse.vue?vue&type=template&id=47d4810a&", function () {
      api.rerender('47d4810a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/ExamTrueFalse.vue"
export default component.exports